import {cadenas} from 'lib.common';

export function genQuery(entidad, campos, atributos) {
   let consulta = '';
   if (campos && campos.length > 0) {
      consulta = `{
        ${entidad} {
            ${campos.map((item) => {
               return item + ' ';
            })}
         }
      }`;
   } else {
      consulta = `{${entidad}}`;
   }
   return consulta;
}

export function procesarCampo(nombre, tipoDato, obligatorio) {
   let paramAlias = '$' + nombre;
   let param = nombre + ':' + paramAlias + ' ';
   paramAlias = paramAlias + ':' + tipoDato;
   if (obligatorio) {
      paramAlias = paramAlias + '!';
   }
   return [paramAlias + ' ', param];
}

function queryParametros(arregloCampos, parametros = 'paramRecuperarEliminar') {
   let campos = '';
   let param = '';
   let paramAlias = '';
   let paramAliasAux = '';
   let paramAux = '';
   for (let i = 0; i < arregloCampos.length; i++) {
      const campo = arregloCampos[i];
      if (campo.usarEnRespuesta) {
         const nombre = campo.nombreRecuperar || campo.nombre;
         campos = campos + nombre + ' ';
      }
      if (campo[parametros]) {
         [paramAliasAux, paramAux] = procesarCampo(campo.nombre, campo.tipoDato, campo.obligatorio);
         param = param + paramAux;
         paramAlias = paramAlias + paramAliasAux;
      }
   }
   return [paramAlias, param, campos];
}

export async function generarConsulta(
   arregloCampos,
   operacion,
   query,
   crud = 'recuperar',
   resultadoCadena = false
) {
   let alias = query.toUpperCase();
   alias = operacion + ' ' + alias;
   let parametrosAlias, parametros, campos;
   crud = crud.toLowerCase();

   if (crud === 'agregar' || crud === 'actualizar') {
      [parametrosAlias, parametros, campos] = await queryParametros(
         arregloCampos,
         'param' + (await cadenas.primeraLetraMayus(crud))
      );
   } else {
      [parametrosAlias, parametros, campos] = await queryParametros(arregloCampos);
   }

   let consulta;
   if (resultadoCadena) {
      consulta = alias + '(' + parametrosAlias + ') {' + query + '(' + parametros + ')}';
   } else {
      consulta =
         alias + '(' + parametrosAlias + ') {' + query + '(' + parametros + ') {' + campos + '}}';
   }
   return consulta;
}

export function hidden(item) {
   if (item && item.hidden) {
      const auxConfig = {
         prod: item.hidden.prod === undefined ? false : item.hidden.prod,
         dev: item.hidden.dev === undefined ? false : item.hidden.dev,
         test: item.hidden.test === undefined ? false : item.hidden.test
      };
      return accesoPorEntorno(auxConfig);
   } else {
      return false;
   }
}

export function accesoPorEntorno({prod = true, dev = true, test = true}) {
   switch (process.env.NODE_ENV) {
      case 'production':
         if (process.env.REACT_APP_DS_ENV === 'PROD') {
            return prod;
         }
         if (process.env.REACT_APP_DS_ENV === 'DEV') {
            return false;
         }
         if (process.env.REACT_APP_DS_ENV === 'TEST') {
            return test;
         }
         break;
      case 'development':
         if (process.env.REACT_APP_DS_ENV === 'PROD') {
            return prod;
         }
         if (process.env.REACT_APP_DS_ENV === 'DEV') {
            return dev;
         }
         if (process.env.REACT_APP_DS_ENV === 'TEST') {
            return test;
         }
         break;
      default:
         return false;
   }
}

export function msgWhatsapp(nro, msg, codPais = '51') {
   const uri = `https://api.whatsapp.com/send?phone=${codPais}${nro.replace(
      /\s+/g,
      ''
   )}&text=${encodeURIComponent(msg)}`;
   return uri;
}
import format from 'date-fns/format';
import compareAsc from 'date-fns/compareAsc';
export function formatddMMyyyy(fecha) {
   return format(fecha, 'dd/MM/yyyy');
}
export function compareAscOnlyDate(date1, date2) {
   return compareAsc(new Date(date1.toDateString()), new Date(date2.toDateString()));
}
export function genEmojiLabelIdInfo(id = '', info = '') {
   let labelId = `🆔 ${id}`;
   let labelInfo = `🔡 ${info}`;
   if (id && info) {
      return `${labelId} ${labelInfo}`;
   }
   if (id) {
      return labelId;
   }
   return labelInfo;
}
export function rutaPermisosAutorizado(ruta, permisos = []) {
   if (permisos.find((item) => item.ruta === ruta)) {
      return true;
   }
   return false;
}
export function blobToBase64(blob) {
   return new Promise((resolve, _) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.readAsDataURL(blob);
   });
}
export function getContrastColor(hexColor) {
   // Eliminar numeral si existe
   const cleanedHex = hexColor.replace(/^#/, '');

   // Convertir hexadecimal a RGB
   const bigint = parseInt(cleanedHex, 16);
   const r = (bigint >> 16) & 255;
   const g = (bigint >> 8) & 255;
   const b = bigint & 255;

   // Calcular luminicencia usando la formula de luminicencia relativa
   const lum = (0.299 * r + 0.587 * g + 0.114 * b) / 255;

   // Elegir blanco o negro de acuerdo a la luminicencia
   return lum > 0.5 ? 'black' : 'white';
}

export class Screen {
   title;
   to;
   path;
   constructor(title, path) {
      this.title = title;
      this.path = path;
      this.to = this.path;
   }
}
